import { LabelsType } from './types';

export const DEFAULT_LABELS = {
    calculatorTitle: 'Ansök om lån',
    loanAmountTitle: 'Lånebelopp',
    tenorTitle: 'Återbetalningstid',
    governmentIdPlaceholder: 'Personnummer ÅÅMMDD-XXXX',
    governmentIdValidationMessage: 'Kontrollera att det angivna personnumret är korrekt.',
    governmentIdValidationFailedMessage: 'Ett tekniskt fel inträffade, var god försök igen senare',
    monthlyAmountTitle: 'Månadskostnad',
    applyButton: 'Fortsätt ansökan',
    submitButton: 'Börja ansökan',
    currency: 'kr',
    year: 'år',
    years: 'år',
    commonTerms: 'Allmänna villkor',
    secci: 'SEKKI',
    descriptionTitle: 'Så här räknar vi',
    descriptionText: 'Månadsbeloppet är indikativt, ett exakt värde lämnas efter en kreditbedömning.',
    errorLoading: 'Kunde inte påbörja ansökan, var god försök senare',
    creditCheckInfo: 'Det görs ingen kreditupplysning i detta steg',
    highAmountLowYears: 'Valet av återbetalningstid är inte optimalt för att få låg månadskostnad.',
    mediumAmountHighYears: 'En kortare återbetalningstid kan vara mer optimalt för det valda lånebeloppet.',
    lowAmountHighYears: 'Valet av återbetalningstid är inte optimalt då du kommer få betala på lånet under lång tid.',
    blockLowAmountHighYears: 'Återbetalningstiden du valt är för lång för det valda beloppet. Vänligen välj en kortare återbetalningstid.',
    blockHighAmountLowYears: 'FI: Block high amount with low years',
    informationConsolidation: 'NO: Show if tenor is 5 year or higher',
    fallbackTitle: 'Något verkar trasigt',
    fallbackDescription: 'Just nu kan du inte använda vårt ansökningsformulär. Testa igen om en stund eller chatta med oss för snabbast hjälp.',
    noCreditCheck: 'Det görs ingen kreditupplysning i detta steg',

    // ---------------------
    // ----- General ------
    // ---------------------
    backButton: 'Tillbaka',
    continueButton: 'Fortsätt',
    loading: 'Laddar...',
    formStepOneTitle: 'Personlig information',
    formStepTwoTitle: 'Ekonomisk information',
    formStepThreeTitle: 'Sammanfattning',
    formStepResultTitle: 'Lånebesked',
    yes: 'Ja',
    no: 'Nej',
    governmentId: 'Personnummer',
    landingPageButton: 'Till startsidan',
    errorTitle: 'Det uppstod ett fel',
    errorDescription: 'Tyvärr uppstod ett tekniskt fel. Försök igen senare.',
    contactUsTitle: 'Har du frågor? Kontakta oss:',
    contactUsInformation:
        '<p><strong>E-post</strong>: <a class="external-link" href="mailto:kundservice@resurs.se" target="_blank" rel="noopener noreferrer">kundservice@resurs.se</a>, eller besök vår <a href="/kundservice" target="_blank" rel="noopener">FAQ på resursbank.se</a> för mer information</p>',
    // ---------------------
    // ----- Step One ------
    // ---------------------
    phoneMobile: 'Mobiltelefon',
    phoneMobileInfoText: 'Ange ditt mobilnummer så att vi kan kontakta dig om det behövs.',
    contactEmail: 'E-post',
    contactEmailInfoText: 'Ange din e-postadress så att vi kan skicka information om din ansökan.',
    personalInformation: 'Personlig information',
    purposeOfLoan: 'Syfte med lånet',
    choosePurposeOfLoan: 'Välj syfte med lånet',
    choosePurposeOfLoanInfoText: 'Välj syfte med lånet',
    MOTOR: 'Bil/MC',
    WEDDING: 'Bröllop',
    BOAT: 'Båt',
    INVESTMENT: 'Investering (t.ex. aktier)',
    DRIVERS_LICENSE: 'Körtkort',
    INTERIOR: 'Inredning (t.ex. möbler, hemelektronik',
    RENOVATION: 'Renovering',
    TRAVEL: 'Resa/Fritid',
    CONSOLIDATE_LOANS: 'Samla lån/kredit',
    DENTAL_OR_OTHER_CARE: 'Sjuk- eller tandvård',
    STUDIES: 'Studier',
    OTHER: 'Övrig konsumtion',
    HOUSING_MORTGAGE_LOAN: 'Köp av bostad',
    livingSituation: 'Livssituation',
    applicantMaritalStatus: 'Civilstånd',
    SINGLE: 'Singel',
    MARRIED: 'Gift',
    DOMESTIC_PARTNER: 'Sambo',
    numberChildrenNotOfAge: 'Antal barn under 21 år',
    numberChildrenNotOfAgeInfoText: 'Ange antal barn under 21 år som du har.',
    applicantHabitationForm: 'Boendeform',
    APARTMENT: 'Lägenhet',
    CONDOMINIUM: 'Bostadsrätt',
    DETACHED_HOUSE: 'Villa',
    employment: 'Anställning',
    employmentType: 'Anställningsform',
    FAST_ANSTALLD: 'Anställd',
    VIKARIAT: 'Visstidsanställd',
    EGEN_FORETAGARE: 'Eget företag',
    PENSIONAR: 'Pensionär',
    ARBETSLOS: 'Arbetslös',
    employmentYearPlaceholder: 'Välj år',
    employmentMonthPlaceholder: 'Välj månad',
    employmentYearErrorMessage: 'Ange ett giltigt år och månad.',
    employmentMonthFromInfoText: 'Ange månad när du började din nuvarande anställning.',
    employmentYearFromInfoText: 'Ange år när du började din nuvarande anställning.',
    employmentMonthUntilInfoText: 'Ange månad för när du slutade din nuvarande anställning.',
    employmentYearUntilInfoText: 'Ange år när du slutade din nuvarande anställning.',
    employmentTypeQualifyingText: 'Är din anställning inom utbildning eller vård & omsorg?',
    employmentYearFromTitle: 'Anställd/Eget företag/Pensionär sedan',
    employmentYearUntilTitle: 'Anställd t o m',
    applicantEmployer: 'Arbetsgivare',
    applicantEmployerInfoText: 'Ange arbetsgivare eller företagets namn om du är egenföretagare.',

    coapplicant: 'Medsökande',
    coApplicantMonthlyIncomeGross: 'Medsökande: månadsinkomst före skatt',
    coapplicantCheckbox:
        'Bocka för om du söker tillsammans med en annan person. Om du ansöker tillsammans med en medsökande så kan dina chanser öka att få lånet beviljat',
    coapplicantMonthlyIncomeGrossInfoText: 'Ange din medsökandes månadsinkomst före skatt',
    coapplicantPhoneMobileInfoText: 'Ange din medsökandes mobilnummer så att vi kan kontakta hen om det behövs.',
    coapplicantContactEmailInfoText: 'Ange din medsökandes e-postadress så att vi kan skicka information om er ansökan.',
    coapplicantEmploymentTypeQualifyingText: 'Är medsökandes anställning inom utbildning eller vård & omsorg?',
    coapplicantEmploymentMonthFromInfoText: 'Ange månad när medsökande började sin nuvarande anställning.',
    coapplicantEmploymentYearFromInfoText: 'Ange år när medsökande började sin nuvarande anställning.',
    coapplicantEmploymentMonthUntilInfoText: 'Ange månad för när medsökande slutade sin nuvarande anställning.',
    coapplicantEmploymentYearUntilInfoText: 'Ange år när medsökande slutade sin nuvarande anställning.',
    coapplicantEmployerInfoText: 'Ange arbetsgivare eller företagets namn om medsökande är egenföretagare.',
    // ---------------------
    // ----- Step Two ------
    // ---------------------
    householdEconomyTitle: 'Ekonomisk information',
    monthlyIncomeGross: 'Månadsinkomst före skatt',
    monthlyIncomeGrossInfoText: 'Ange din månadsinkomst före skatt',
    livingExpenses: 'Boendekostnad',
    livingExpensesInfoText: 'Ange hushållets boendekostnad per månad',
    otherLoanExpenses: 'Månadskostnad övriga lån/krediter',
    otherLoanExpensesInfoText: 'Kostnader övriga lån/krediter per månad exkl. bolån',
    paymentAccountTitle: 'Bankkonto och utbetalning',
    paymentAccountInfo:
        'För att kunna signera din ansökan med BankID måste du ange clearing- och kontonummer. Hoppar du över det här steget kan du bara få låneavtalet hemskickat med posten.',
    bankName: 'Banknamn',
    clearingNumber: 'Clearingnummer',
    accountNumber: 'Kontonummer',
    insuranceTitle: 'Betalförsäkring',
    insuranceInfoText:
        'Skydda ditt lån om du skulle bli arbetslös, sjukskriven, inlagd på sjukhus eller råka ut för ett dödsfall till följd av olycka. Premien är 0,4% av din totala skuld och max 297 kr. Försäkringen täcker din månadskostnad för lånet i upp till 12 månader.',
    insuranceApproveText: 'Ja tack, jag vill teckna betalförsäkring',
    insuranceApproveInfoText:
        'Genom att tacka Ja godkänner jag att försäkringsinformation och villkor tillhandahålls mig via <a href="%s" target="_blank">www.resursbank.se*</a> och jag bekräftar att jag tagit del av, sparat ner och godkänner <strong>försäkringsinformation och villkor</strong> som framgår nedan. Vidare bekräftas att jag accepterar de <strong>behovsantaganden</strong> som ligger till grund för försäkringen, och som framgår av För- och efterköpsinformationen, och att jag därigenom även uppfyller förutsättningarna för att kunna teckna försäkringen.',
    insuranceLinksTitle: 'Försäkringsinformation och villkor',
    clearingNumberInfo: 'Ange ditt clearingnummer',
    accountNumberInfo: 'Ange ditt kontonummer',
    clearingTooShort: 'Clearingnummer måste innehålla minst 4 siffror',
    accountOutOfRange: 'Kontonummer innehåller för få eller för många siffror',
    missingClearingWhenAccount: 'Vänligen ange clearingnummer',
    missingAccountWhenClearing: 'Vänligen ange kontonummer',
    // ---------------------
    // ----- Step Three ------
    // ---------------------
    summaryTitle: 'Sammanfattning',
    summaryInfoText:
        'Kontrollera att uppgifterna nedan stämmer innan du skickar in din låneansökan. Om du vill/behöver ändra något kan du ändra det här.',
    change: 'Ändra',
    transferAccount: 'Utbetalningskonto',
    loan: 'Lån',
    submitForm: 'Skicka in ansökan',
    approveConditionsTitle: 'Acceptera villkor',
    approveConditionsInfo:
        'Vid tecknande av avtal med Resurs Bank ingår du i Resurskoncernens kundregister. Det huvudsakliga ändamålet med vår behandling av personuppgifter är att samla in, kontrollera och registrera de uppgifter som krävs inför ingående av avtal med dig samt för att dokumentera, administrera och fullgöra avtal. Personuppgifter kan även behandlas som underlag för marknadsföring. När behandling sker för marknadsföringsändamål kan även profilering förekomma för att rikta anpassade erbjudanden till dig varvid du kan erbjudas alternativ produkt eller kontaktas av en av Resurs Banks samarbetspartners. Fullständig information om vår behandling av personuppgifter och dina rättigheter hittar du i våra villkor för behandling av personuppgifter. Jag är införstådd med att jag genom att kontakta Resurs Bank kan begära spärr mot direktmarknadsföring. Jag försäkrar att lämnade uppgifter är riktiga och fullständiga och tillåter att ansökan kreditprövas varvid arbetsgivaren kan komma att kontaktas. Resurs Bank förbehåller sig fri prövningsrätt. Jag försäkrar vidare att jag i samband med min ansökan fått information om och tagit del av Standardiserad europeisk konsumentkreditinformation (SEKKI) och Resurs Banks allmänna villkor för privat konto- och kortkredit samt privatlån för Sverige, vars bestämmelser härmed accepteras. Avtalet jämte dessa handlingar tillhandahålles via Mina Sidor på www.resursbank.se. *',
    approveConditionsError: 'Du måste acceptera villkoren för att skicka in ansökan',
    personalDataPolicyTitle: 'Information om behandling av personuppgifter',
    personalDataPolicyText:
        '<p>I ansökan har du blivit ombedd att lämna vissa personuppgifter om dig själv såsom personnummer, namn, mailadress, telefonnummer, uppgifter om anställning och ditt hushålls ekonomi. Denna information kommer att användas och behandlas av oss i syfte att behandla och kreditpröva din ansökan exempelvis genom att kontrollera din ekonomi, verifiera dina uppgifter och annan bakgrundsinformation och för att kunna erbjuda dig en alternativ produkt. Behandling av personuppgifter sker också för att vi ska kunna uppfylla våra förpliktelser enligt gällande rätt, t.ex. kontroll mot sanktionslistor. Personuppgifterna behandlas vidare inom ramen för vårt berättigade intresse för marknads- och kundanalyser som utgör underlag för marknadsföring och metod- och affärsutveckling samt som underlag för finansiell rådgivning. Ändamålen för behandlingarna omfattar alla personuppgifter som du lämnar i din ansökan, all ytterligare information som du förser oss med i anledning av din ansökan och all annan information som vi inhämtar från tredje part i syfte att behandla din ansökan, t.ex. information om dina ekonomiska förhållanden. Vi kan komma att lämna ut personuppgifterna till bolag i vår koncern samt till våra samarbetspartners för de ovan angivna ändamålen.</p><p>Personuppgifterna lagras och gallras i enlighet med gällande lagstiftning. Du har som kund rätt att få information om vilka personuppgifter vi har registrerat om dig och hur dessa uppgifter används. Du har även rätt att begära att vi rättar eller tar bort felaktiga uppgifter. Du kan alltid vända dig till oss för att begära spärr mot direktmarknadsföring (s.k. direktreklamspärr). Du har också rätt att i vissa fall motsätta dig behandling som grundas på vårt berättigade intresse. Du kan även vända dig till Datainspektionen med klagomål.</p><p>Resurs Bank AB (org.nr. 516401-0208), Box 22209, 250 24 Helsingborg, är ansvarigt för behandlingen av personuppgifter. Vid frågor om personuppgiftsbehandlingen kan du skriva till vårt dataskyddsombud eller ringa till oss på 0771-11 22 33. För mer information om hur vi behandlar personuppgifter, <a href="http://www.resursbank.se" target="_blank">se vår hemsida.</a></p>',
    // ---------------------
    // ----- Approved application ------
    // ---------------------
    approvedTitle: 'Din ansökan är godkänd',
    approvedMonthlyCost: 'Månadskostnad',
    approvedEffectiveInterest: 'Effektiv ränta',
    approvedLoanDetailsTitle: 'Lånedetaljer',
    approvedTenor: 'Löptid',
    months: 'månader',
    approvedNominalInterest: 'Nominell ränta',
    approvedEffectiveInterestDetail: 'Effektiv ränta',
    approvedTotalRepayment: 'Totalkostnad',
    approvedFeesAndInterest: 'Avgifter & räntor',
    approvedAdminFee: 'Administrationsavgift',
    approvedArrangementFee: 'Uppläggningsavgift',
    approvedConsolidationDemand: 'Krav på att lösa befintliga lån',
    approvedAcceptButton: 'Godkänn erbjudandet',
    // ---------------------
    // ----- Manual application ------
    // ---------------------
    manualTitle: 'Tack för din ansökan',
    manualDescription: 'Vi behöver göra en manuell granskning av din ansökan. Vi kontaktar dig inom kort.',
    // ---------------------
    // ----- Rejected application ------
    // ---------------------
    rejectedTitle: 'Tyvärr, din ansökan nekades',
    rejectedDescription: 'Vi kan tyvärr inte bevilja dig ett lån just nu. Du är välkommen att höra av dig till oss om du har några frågor.',
    // ---------------------
    // ----- Submitted application ------
    // ---------------------
    submittedTitle: 'Tack!',
    submittedDescription: 'Din ansökan är inskickad och kommer att behandlas.',
};

export const getLabel = (labels: LabelsType, key: keyof LabelsType, replacements?: Record<string, string | number>) => {
    const label = labels?.[key] || DEFAULT_LABELS[key];

    let result = label;

    if (replacements) {
        Object.entries(replacements).forEach(([placeholder, value]) => {
            const regex = new RegExp(`{{\\s*${placeholder}\\s*}}`, 'g');
            result = result.replace(regex, String(value));
        });
    }

    return result.replace(/\s*style="[^"]*"/g, '');
};
